import React, { FC } from 'react';
import { Row, Col } from 'antd';
import { FormattedMessage } from 'react-intl';

import { LayoutOverlay, LayoutCardList, LayoutCardType } from 'src/modules/layout';
import { useProductCards } from 'src/modules/products/listing/components/overview/ProductsListingOverview';
import { withBreakpoints } from 'react-breakpoints';
import styles from './ArticlesInstagramDetailsOverlay.module.scss';

import { ArticlesInstagramLocalizedEntity } from '../../types';

interface ArticlesInstagramDetailsOverlayProps {
  data: ArticlesInstagramLocalizedEntity | null;
  currentBreakpoint: string;
  onClose: () => void;
}

const ArticlesInstagramDetailsOverlay: FC<ArticlesInstagramDetailsOverlayProps> = (props) => {
  const { data, onClose, currentBreakpoint } = props;
  const productCards = useProductCards(data?.products, null, currentBreakpoint);

  if (!data) return null;

  const instagramImgUrl = data?.media[0]?.url;

  return (
    <LayoutOverlay display={!!data} onClose={onClose}>
      <div className={styles.titleContainer}>
        <h3 className={styles.title}>
          <FormattedMessage id="page/magazine/instagram_title" />
        </h3>
      </div>
      <div className={styles.container}>
        <Row>
          <Col sm={{ span: 24 }} md={{ span: 8 }}>
            <div className={styles.instagramImgContainer}>
              <img className={styles.instagramImg} src={instagramImgUrl} />
              <p className={styles.caption}>{data.caption}</p>
            </div>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 16 }}>
            <LayoutCardList
              colProps={{ md: { span: 12 }, sm: { span: 12 }, xs: { span: 12 } }}
              type={LayoutCardType.Product}
              objectFit="contain"
              items={productCards}
            />
          </Col>
        </Row>
      </div>
    </LayoutOverlay>
  );
};

export default withBreakpoints(ArticlesInstagramDetailsOverlay);
